import axios from "api";

export const fetchProquoteSettings =  async () => {
    let proquoteSettings = JSON.parse(sessionStorage.getItem('proquoteSecurity'));
    if(!proquoteSettings){
      const {data} = await axios.get('/api/GetProQuoteSettings');
      proquoteSettings = data;
      sessionStorage.setItem('proquoteSecurity', JSON.stringify(data))
    }
    return proquoteSettings;
  }